module.exports = __webpack_public_path__ + "img/logo.86bc7f99.png";